import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';
import { PrimaryDark } from '../../../../../../../../styling/theme';

export const RoleDetailsWrapper = styled.div`
  grid-column: 1/-1;
  display: grid;
  /* grid-gap: 12px; */
  margin: ${(props) =>
    props.isCollapseChildren ? '0 12px 0 12px' : '0 12px 12px 12px'};
  :last-child {
    padding-bottom: 0;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    margin: ${(props) =>
      props.isCollapseChildren ? '0 14px 0 14px' : '0 14px 14px 14px'};
  }
  @media ${breakpointsMinWidth.desktopSm} {
    margin: ${(props) =>
      props.isCollapseChildren ? '0 16px 0 16px' : '0 16px 16px 16px'};
  }

  @media ${breakpointsMinWidth.desktopMd} {
    margin: ${(props) =>
      props.isCollapseChildren ? '0 20px 0 20px' : '0 20px 20px 20px'};
  }
`;

export const RoleLabelContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: 8px;
  align-items: center;
  margin-bottom: 12px;
  @media ${breakpointsMinWidth.tabletLg} {
    grid-column-gap: 12px;
  }
`;

export const RoleLabel = styled.div`
  background: ${PrimaryDark};
  border-radius: 4px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  height: 40px;
  align-items: center;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  pointer-events: auto;
  user-select: none;

  cursor: grab;

  @media ${breakpointsMinWidth.mobileMicroLg} {
    padding: 0 16px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    height: 36px;
    padding: 0 9px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    padding: 0 10px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    height: 40px;
    padding: 0 14px;
    font-size: 14px;
  }
`;

export const RoleChildren = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 12px;
  margin-right: 24px;
  max-height: 100%;
  transition: all 0.3s ease-in-out;

  ${(props) => {
    const { isCollapseChildren } = props;

    if (isCollapseChildren) {
      return css`
        max-height: 0;
        overflow: hidden;
      `;
    }
    return css``;
  }}

  @media ${breakpointsMinWidth.tabletLg} {
    margin-right: 28px;
  }
`;

export const LeftRoleLabel = styled.div`
  display: flex;
  align-items: center;
`;
export const CheckMark = styled.span`
  pointer-events: auto;
  cursor: pointer;
`;

export const JobTitle = styled.span`
  vertical-align: middle;
  line-height: initial;
`;

export const RightRoleLabel = styled.div`
  user-select: none;
  display: grid;
  grid-template-columns: repeat(3, min-content);
  grid-column-gap: 4px;
`;

export const Button = styled.span`
  cursor: pointer;
`;
export const AddRole = styled(Button)``;
export const DeleteRole = styled(Button)`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
`;

export const CollapseRole = styled(Button)`
  svg {
    transform: ${(props) =>
      !props.isCollapseChildren ? 'rotate(270deg)' : 'rotate(90deg)'};
    transition: transform 0.4s ease-in-out;
  }
`;
